(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("fs"));
	else if(typeof define === 'function' && define.amd)
		define(["fs"], factory);
	else if(typeof exports === 'object')
		exports["scribble"] = factory(require("fs"));
	else
		root["scribble"] = factory(root["fs"]);
})(self, (__WEBPACK_EXTERNAL_MODULE__89__) => {
return 